/**
 * Measurements two files have to agree on.
 *
 * `STICKY_TOP` is how much of the top of the window the frame keeps covered
 * once the sky band has scrolled away: the fixed bar and the sticky tabs under
 * it (App.tsx, styles.css under "The frame"). Anything else that sticks, like
 * the Security page's contents rail, sticks below it. A CSS expression rather
 * than a number, because the two heights are custom properties in styles.css
 * and that is the one place they are written down.
 */
export const STICKY_TOP = 'calc(var(--rw-bar-h) + var(--rw-tabs-h))';

/**
 * How wide the contents rail is, and how far it sits from the frame.
 *
 * These set the breakpoint below which the rail is hidden, and that
 * relationship is the reason they are written down together rather than inline.
 * The rail hangs into the margin beside a page capped at `PAGE_MAX`, so the
 * space available to its left is `(viewport - PAGE_MAX) / 2 + PAGE_PADDING`,
 * and it needs `RAIL_WIDTH + RAIL_GAP` of that plus a little air.
 *
 * At the values below that works out just under 1100px, which is the media
 * query in `styles.css`. Change any of these and that number moves — the
 * symptom of forgetting is a rail overlapping the window edge on a laptop.
 */
export const RAIL_WIDTH = 160;
export const RAIL_GAP = 24;
